import { httpClient } from "./client";
import type {
  InquiryApi,
  InquiryListResponse,
  InquiryResponse,
  InquiryAssigneeListResponse,
} from "./interfaces";

const endpoint = "/social/inquiries";
const threadPath = (id: string) => `${endpoint}/${encodeURIComponent(id)}`;

export const inquiryApi: InquiryApi = {
  list: (params = {}, signal) => {
    const query = new URLSearchParams();
    if (params.scope !== undefined) query.set("scope", params.scope);
    if (params.facility_id != null)
      query.set("facility_id", params.facility_id);
    if (params.lifecycle !== undefined)
      query.set("lifecycle", params.lifecycle ?? "all");
    if (params.cursor != null) query.set("cursor", params.cursor);
    if (params.limit !== undefined) query.set("limit", String(params.limit));
    return httpClient.get<InquiryListResponse>(
      `${endpoint}${query.size ? `?${query}` : ""}`,
      { signal },
    );
  },
  get: (id, signal) =>
    httpClient.get<InquiryResponse>(threadPath(id), { signal }),
  listAssignees: (id, params = {}, signal) => {
    const query = new URLSearchParams();
    if (params.cursor != null) query.set("cursor", params.cursor);
    if (params.limit !== undefined) query.set("limit", String(params.limit));
    return httpClient.get<InquiryAssigneeListResponse>(
      `${threadPath(id)}/assignees${query.size ? `?${query}` : ""}`,
      { signal },
    );
  },
  create: (data) => httpClient.post<InquiryResponse>(endpoint, data),
  assign: (id, data) =>
    httpClient.patch<InquiryResponse>(`${threadPath(id)}/assignment`, data),
  transition: (id, data) =>
    httpClient.post<InquiryResponse>(`${threadPath(id)}/transitions`, data),
};
